enum AppeasementState {
    Pending = 'Pending',
    Approved = 'Approved',
    Denied = 'Denied',
    PendingExport = 'PendingExport',
    Exported = 'Exported',
    Mailed = 'Mailed',
    Issued = 'Issued',
}

export default AppeasementState;
